import { type AllProfileWorkOpportunityResultsListView_userAccount$data } from '#app/__generated__/relay/AllProfileWorkOpportunityResultsListView_userAccount.graphql.js';

type OpportunityEdges =
  AllProfileWorkOpportunityResultsListView_userAccount$data['jobPostings']['edges'];

export const getFilteredOpportunities = <T extends OpportunityEdges>(
  edges?: T,
): T => {
  return (edges?.filter(({ node }) => {
    return node.visitorCanEdit
      ? true
      : node.status === 'APPROVED' ||
          (node.status === 'COMPLETED' &&
            node.visitorApplication?.paidProjectV2.status === 'IN_PROGRESS');
  }) ?? []) as unknown as T;
};
